module.exports = __webpack_public_path__ + "static/media/kindergartens_blue.b68fefca.svg";